import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

const Modal = ({ title, size, isOpen, content, setIsOpen,disableBackdropClick,disableEscapeKeyDown, heightVal }) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={size}
      disableBackdropClick={disableBackdropClick?true:false}
      disableEscapeKeyDown={disableEscapeKeyDown?true:false}
    >
      {title ? (
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent style={{ overflowX:"hidden"}}>{content}</DialogContent>
      
    </Dialog>
  );
};

export default Modal;
